import * as types from '../mutation-types'
import moment from 'moment/moment.js'

const state = {
  token: localStorage.getItem('access_token'),
  info: JSON.parse(localStorage.getItem('user_info')) || {
    userID: '',
    name: '',
    position: '',
    createdAt: ''
  },
  clients: JSON.parse(localStorage.getItem('user_clients')) || [],
  permissions: JSON.parse(localStorage.getItem('user_permissions')) || [],
  defaultMenu: JSON.parse(localStorage.getItem('user_defaultMenu')) || {},
  slideMenuItems: JSON.parse(localStorage.getItem('user_menu_items')) || [],
  timeout: JSON.parse(localStorage.getItem('user_timeout')) || {
    timeLogin: moment().subtract(1, 'days'),
    timeInactivitySession: 1,
    timeEndSession: 1
  }
}

const mutations = {
  [types.AUTH_LOGGED_IN] (state, data) {
    state.token = true
    localStorage.setItem('access_token', true)

    let objTimeout = {
      timeLogin: moment(),
      timeInactivitySession: data.timeInactivitySession,
      timeEndSession: data.timeEndSession
    }

    state.timeout = objTimeout
    localStorage.setItem('user_timeout', JSON.stringify(objTimeout))
  },
  [types.AUTH_LOGGED_OUT] (state) {
    cleanState(state)
    localStorage.removeItem('access_token')
    localStorage.removeItem('user_info')
    localStorage.removeItem('user_clients')
    localStorage.removeItem('user_permissions')
    localStorage.removeItem('user_defaultMenu')
    localStorage.removeItem('user_menu_items')
    localStorage.removeItem('user_timeout')
  },
  [types.USER_SET_PERMISSIONS] (state, permissions) {
    state.permissions = JSON.parse(permissions)
    localStorage.setItem('user_permissions', permissions)
  },
  [types.USER_SET_DEFAULT_MENU_ITEM] (state, defaultMenu) {
    state.defaultMenu = JSON.parse(defaultMenu)
    localStorage.setItem('user_defaultMenu', defaultMenu)
  },
  [types.USER_SET_SLIDE_MENU_ITEMS] (state, slideMenuItems) {
    state.slideMenuItems = slideMenuItems
    localStorage.setItem('user_menu_items', JSON.stringify(slideMenuItems))
  },
  [types.USER_FETCH_INFO] (state, info) {
    state.info = JSON.parse(info)
    localStorage.setItem('user_info', info)
  },
  [types.USER_FETCH_CLIENTS] (state, clients) {
    state.clients = JSON.parse(clients)
    localStorage.setItem('user_clients', clients)
  }
}

function cleanState (state) {
  state.token = null
  state.userID = ''
  state.info = {}
  state.clients = []
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js